import React, { useContext, useEffect } from 'react';
import {
  Box, Container, Divider, Stack,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import Images from '../../../../Configs/images';

export default function Component({
  classes, error, message,
}) {
  const navigate = useNavigate();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const openEmail = () => {
    window.location.href = 'mailto:oenobank@support.com';
  };

  const makeCall = () => {
    window.open('tel:+33881212121212');
  };

  return (
    <Elements.PageBase navigate={navigate}>
      <Box className={classes.root}>
        <Elements.Navigator title="Contact Us" />
        <Container sx={{ mt: 2 }}>
          <Stack direction="column" spacing={3}>
            <Box onClick={openEmail}>
              <Box fontWeight="600">Email</Box>
              <Box mt="2px" color="#404852" fontSize={12}>oenobank@support.com</Box>
              <Divider sx={{ mt: 1 }} />
            </Box>
            <Box onClick={makeCall}>
              <Box fontWeight="600">Customer service number</Box>
              <Box mt="2px" color="#404852" fontSize={12}>+33881212121212</Box>
              <Divider sx={{ mt: 1 }} />
            </Box>
            <Box>
              <Box fontWeight="600">Social Media</Box>
              <Box mt="2px" display="flex" gap={2}>
                <Link to="/" className="link black">
                  <img alt="twitter" src={Images.Twitter} />
                </Link>
                <Link to="/" className="link black">
                  <img alt="facebook" src={Images.Facebook} />
                </Link>
                <Link to="/" className="link black">
                  <img alt="linkedin" src={Images.Linkedin} />
                </Link>
                <Link to="/" className="link black">
                  <img alt="instagram" src={Images.Instagram} />
                </Link>
              </Box>
              <Divider sx={{ mt: 1 }} />
            </Box>
          </Stack>
        </Container>
      </Box>

      <Elements.Footer />
    </Elements.PageBase>
  );
}
